<div fxLayout="column" fxFlexFill>
  <div fxLayout="column" fxFlexFill class="spinner-container" *ngIf="dataSource.loading$ | async">
    <mat-spinner></mat-spinner>
  </div>
  <div fxFlex="auto" fxFlexFill class="table-container">
    <mat-table [dataSource]="dataSource" [multiTemplateDataRows]="true" class="regular-table responsive"
               matSort matSortActive="fieldOrder" matSortDirection="desc" matSortDisableClear>

      <ng-container matColumnDef="fieldOrder">
        <mat-header-cell *matHeaderCellDef mat-sort-header="fieldOrder">Order</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Order:</span>
          {{ row.fieldOrder ?? 0 }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="fieldKey">
        <mat-header-cell *matHeaderCellDef mat-sort-header="fieldKey">Field Key</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Field Key:</span>
          <a *ngIf="hasEditAccess" [routerLink]="[detailsUrl, row.id, 'edit']">
            {{ row.fieldKey }}
          </a>
          <span *ngIf="!hasEditAccess">{{ row.fieldKey }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="fieldTitle">
        <mat-header-cell *matHeaderCellDef mat-sort-header="fieldTitle">Field Title</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Field Title:</span>
          {{ row.fieldTitle }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="fieldType">
        <mat-header-cell *matHeaderCellDef mat-sort-header="fieldType">Field Type</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Field Type:</span>
          {{ row.fieldType }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="category">
        <mat-header-cell *matHeaderCellDef mat-sort-header="category">Category</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Category:</span>
          {{ row.category == 0 ? 'Contacts' : 'Other' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="required">
        <mat-header-cell *matHeaderCellDef mat-sort-header="required">Is Required</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Is Required:</span>
          <div style="width: 100%">
            {{ row.required ? 'Yes' : 'No' }}
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="includeInSearch">
        <mat-header-cell *matHeaderCellDef mat-sort-header="includeInSearch">Include In Search</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Include In Search:</span>
          <div style="width: 100%">
            {{ row.includeInSearch ? 'Yes' : 'No' }}
          </div>
        </mat-cell>
      </ng-container>

      <!-- Header and Row Declarations -->
      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns" class="call-logs-row"></mat-row>
    </mat-table>
  </div>
  <mat-paginator fxFlex="initial" [length]="dataSource.dataCount$ | async" [pageSize]="100"></mat-paginator>
</div>
